

const baseUrl = "https://sandbox-router.juspay.io"

const getHeader = (apiKey) => {
    return {
        "Accept": "application/json",
        'Content-Type': "application/json",
        'api-key': apiKey,
    }
}

const pkKey = "pk_test_51KP0OALGEyT9T908Fv0PuwhRMQ2N9sWsrwZQS5hvTan6m6e73Bsv42DyTQwiw63jlluM1tvzeemOrXlE1AvmKY3D00R0yeN1my"

export { baseUrl, getHeader, pkKey }